(function (app) {

    app.provider("userApi",
        [
            function () {
                this.$get = ["crmApiGateway", function (crmApiGateway) {
                    var service = {};

                    //GETS
                    service.searchUserEmailAddresses = function (term) {
                        return crmApiGateway.get(`/Users/Email/Search?q=${term}`);
                    };

                    service.searchUsers = function (term) {
                        return crmApiGateway.getArray(`/Users/Search?q=${term}`);
                    };
                    service.getUsers = function () {
                        return crmApiGateway.getArray("/Users");
                    };

                    service.getCalendarUsers = function () {
                        return crmApiGateway.getArray("/Users/Calendar");
                    };

                    service.get = function (userId) {
                        return crmApiGateway.get(`/Users/${userId}`);
                    };

                    service.getUserHistoryById = userId => {
                        return crmApiGateway.getArray(`/Users/${userId}/History`);
                    };

                    service.getCurrentUserHistory = () => {
                        return crmApiGateway.getArray('/Users/History');
                    };

                    service.getFigAuth = function (userId) {
                        return crmApiGateway.get(`/Users/${userId}/FigAuth`);
                    };

                    service.GetCurrentUser = function () {
                        return crmApiGateway.get("/Users/Me");
                    };

                    service.getUserPerson = function (userId) {
                        return crmApiGateway.get(`/Users/${userId}/Person`);
                    };

                    service.getUserPermissions = function () {
                        return crmApiGateway.get("/Users/Permissions");
                    };

                    service.getUserAccounts = function (userId, nextPageToken) {
                        let url = `/Users/${userId}/Accounts`;

                        if (nextPageToken) {
                            url = `?${url}&nextPageToken=${nextPageToken}`;
                        }

                        return crmApiGateway.getArray(url);
                    };

                    service.getTotalAum = function (userId) {
                        return crmApiGateway.get(`/Users/${userId}/TotalAum`);
                    };

                    service.getTotalIssuedPremium = function (userId) {
                        return crmApiGateway.get(`/Users/${userId}/TotalIssuedPremium`);
                    };

                    service.getUsersDashboardTiles = userId => {
                        return crmApiGateway.get(`/Users/${userId}/DashboardView`);
                    };

                    service.getUserInforceInsuranceAccounts = userId => {
                        return crmApiGateway.get(`/Users/${userId}/InforceInsuranceAccounts`);
                    };

                    // POSTs
                    service.add = function (user) {
                        return crmApiGateway.post("/Users/", user);
                    };

                    service.setUsersDashboardTiles = (userId, tileEnums) => {
                        return crmApiGateway.post(`/Users/${userId}/DashboardView`, tileEnums);
                    };

                    service.exportInforceInsurance = function () {
                        return crmApiGateway.getFilePost(`/Users/InforceInsuranceAccounts/Export`);
                    };

                    service.addUserHistoryEntry = model => {
                        //let model = {
                        //    DisplayName: "Contacts",
                        //    Route: "Home.Contacts",
                        //    TransitionParams: {
                        //        [paramKey]: "[paramValue]"
                        //    }
                        //};
                        return crmApiGateway.post(`/Users/History`, model);
                    };

                    // PUTs
                    service.update = function (user) {
                        return crmApiGateway.put(`/Users/${user.Id}`, user);
                    };

                    service.updateEmail = function (userId, model) {
                        return crmApiGateway.put(`/Users/${userId}/EmailAddress`, model);
                    };

                    service.setIsActive = function (userId, user) {
                        return crmApiGateway.put(`/Users/${userId}/IsActive`, user);
                    };

                    service.updateCalendarView = function (userId, userIds) {
                        return crmApiGateway.post(`/Users/${userId}/CalendarView`, { UserIds: userIds });
                    };

                    service.delete = function (userId) {
                        return crmApiGateway.delete(`/Users/${userId}`);
                    };

                    return service;
                }];
            }
        ]);
})(window.app); // jshint ignore:line